module.exports = __webpack_public_path__ + "img/historyConsultation.93530590.png";